"use strict";

var i18nextBackend = require("i18next-xhr-backend");
var i18nextLocalStorageCache = require("i18next-localstorage-cache");
var i18next = require("i18next");
var jqueryI18next = require("jquery-i18next");
const $ = require("jquery");

i18next.use(i18nextBackend);
i18next.use(i18nextLocalStorageCache);

// Note this has a leading space as its always preceeded by another selector
var i18nSelector = " .i18n";

/**
 init should be called only once per page
*/
function init() {
  jqueryI18next.init(i18next, $);

  var options = getAllOptions("/webchat/");

  var deferred = $.Deferred();

  i18next
    .use(i18nextBackend)
    .use(i18nextLocalStorageCache)
    .init(options, function (err, t) {
      if (err) {
        console.error(err); //all bad failed to initialize
      } else {
        deferred.resolve(i18next); //now we can translate
      }
    });

  return deferred.promise();
}

function getAllOptions(localeContext) {

  var options = {
    //debug: true,
    ns: ["webChat-config", "webChat-messages"],
    defaultNS: "webChat-config",
    lng: "en",
    fallbackLng: "en",
    backend: {
      loadPath: function (lng, ns) {
        return localeContext + "locales/" + lng + "/" + ns + ".json";
      },
    },
    cache: {
      enabled: false,
      // prefix for stored languages
      prefix: "i18next_res_",
      // expiration (10 mins)
      expirationTime: 10 * 60 * 1000,
    },
  };

  return options;
}

/**
 * Returns translation for given key
 */
function translate(key, options) {
  if (key) {
    if (options) {
      return i18next.t(key, options);
    }
    return i18next.t(key);
  }
}

var cachedScriptPromises = {};

$.cachedGetScript = function (url, callback) {
  if (!cachedScriptPromises[url]) {
    cachedScriptPromises[url] = $.Deferred(function (defer) {
      $.getScript(url).then(defer.resolve, defer.reject);
    }).promise();
  }
  return cachedScriptPromises[url].done(callback);
};

module.exports = {
  init: init,
  translate: translate,
  //localize: localize,
  i18nSelector: i18nSelector,
};
